import React from 'react';
import { NotificationManager } from 'react-notifications';
import { _$, _addClass, _setText } from '../../../../controllers/dom';
import { locales } from '../../../../translations/locales';

const NewStatus = (props) => {
    const { locale, theme, ModuleRP } = props;

    const newStatus = () => {
        if (!_$('statusName').value || !_$('statusCode').value) {
            _addClass('statusName', ['border', 'border-danger']);
            return NotificationManager.error(locales[locale].notifications.newGameNameInvalid);
        }
        const newStatus = {
            name: _$('statusName').value,
            code: _$('statusCode').value,
            backgroundColor: _$('background').value,
            textColor: _$('text').value,
            informative: _$('informative').checked,
        };
        ModuleRP.config.newStatus(newStatus);
    };

    const statusPreview = () => {
        const statusName = _$('statusName').value;
        const statusCode = _$('statusCode').value;
        const backgroundColor = _$('background').value;
        const textColor = _$('text').value;
        _setText('statusPreview', `
        <button class='btn btn-sm btn-status' style='color: ${textColor};background: ${backgroundColor}'>
            ${statusName} (${statusCode})
        </button>
        `);
    };

    return (
        <div className={`container p-0 bg-${theme === 'DARK' ? 'dark text-light' : 'light text-dark'}`}>
            <div className="card container p-0 gameInformations mt-5">
                <h5 className="card-header bg-primary">
                    {locales[locale].config.addNewStatus}
                </h5>
                <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                    <form onSubmit={(event) => {
                        event.preventDefault();
                        newStatus();
                    }}>
                        <div className='form-group'>
                            <label htmlFor='statusName'>
                                {locales[locale].config.statusName}
                                <span className='text-info m-1'>{locales[locale].config.required}</span>
                            </label>
                            <input
                                type='text'
                                id='statusName'
                                className='form-control w-100'
                                placeholder={locales[locale].config.statusName}
                                onChange={statusPreview}
                            />
                        </div>
                        <div className='form-group'>
                            <label htmlFor='statusCode'>
                                {locales[locale].config.statusCode}
                                <span className='text-info m-1'>{locales[locale].config.required}</span>
                            </label>
                            <input
                                type='number'
                                id='statusCode'
                                className='form-control w-100'
                                placeholder={locales[locale].config.statusCode}
                                onChange={statusPreview}
                            />
                        </div>
                    </form>
                    <form className='form-inline'>
                        <div className='input-group mb-2 mr-sm-2'>
                            <label htmlFor='background'>{locales[locale].config.backgroundColor}</label>
                            <input type="color" id="background" className='m-2' onChange={statusPreview} />
                        </div>
                        <div className='input-group mb-2 mr-sm-2'>
                            <label htmlFor='text'>{locales[locale].config.textColor}</label>
                            <input type="color" id="text" className='m-2' onChange={statusPreview} />
                        </div>
                    </form>
                    <div id='statusPreview' className='text-center'></div>
                    <div className='form-check'>
                        <input
                            className='form-check-input'
                            type='checkbox'
                            id="informative"
                            defaultChecked={false}
                        />
                        <label className='form-check-label' htmlFor="informative">
                            {locales[locale].config.informativeDescription}
                        </label>
                    </div>
                </div>
                <div className={`card-footer bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                    <button className='btn btn-primary float-right' id='btn-newStatus' onClick={newStatus}>{locales[locale].config.create}</button>
                </div>
            </div>
        </div>
    );
};

export default NewStatus;
